import React from "react";
import { Box, Flex, Text, Heading, Image } from "noshery-ui";
import styled from "styled-components";
import { ALT_IMGS, locations} from "../../constants";
import * as MUI from "@mui/material";

import useDeviceType from "../../hooks/useDeviceType";
import useWindowSize from "../../hooks/useWindowSize";

const TwoRows = styled(Box)`
  display: grid;
  grid-template-columns: 50% 50%;
`;

const Title = styled(Heading)`
  text-align: center;
  font-weight: 800;
`;

const OurLocations = ({ contactUs }) => {
	const { isDesktop } = useDeviceType();
	const { width } = useWindowSize();

	let wrapperParams = { marginTop: `${(width * 5.5) / 100}px` };

	if (contactUs) {
		wrapperParams = { marginTop: `${(width * 3) / 100}px` };
	}

	const titleParams = {
		fontSize: `${(width * (isDesktop ? 3.3 : 5)) / 100}px`,
		lineHeight: `${(width * (isDesktop ? 4.4 : 6)) / 100}px`,
	};

	return (
		<Box {...wrapperParams}>
			<Title {...titleParams} bold>
        Our Locations
			</Title>
			<Flex
				mt={`${(width * 1.7) / 100}px`}
				alignItems="center"
				justifyContent="center"
			>
				<TwoRows>
					{locations.map((location, index) => {
						if(index === 2) return null;
						return (
							<Box key={index} padding={`${(width * 1.7) / 100}px`}>
								<SingleLocation {...location} />
							</Box>
						);
					})}
				</TwoRows>
			</Flex>
		</Box>
	);
};

export default OurLocations;

const SingleLocation = ({
	src,
	title,
	address1,
	address2,
	phone,
	openHours,
	value,
	comingSoon
}) => {
	const { isDesktop } = useDeviceType();
	const { width } = useWindowSize();

	const boxShadow1 = `${(width * 0.24) / 100}px`;
	const boxShadow2 = `${(width * 1) / 100}px`;

	const boxShadow3 = `${(width * 0.14) / 100}px`;
	const boxShadow4 = `${(width * .7) / 100}px`;

	const hover = comingSoon ? {
		boxShadow: `${boxShadow3} ${boxShadow3} ${boxShadow4} ${boxShadow4} #F1A637`,      
		backgroundColor: "#F7F7F7",
		border: "1px solid #F1A637",
		transition: ".1s",
	} : {};

	const boxParams = {
		backgroundColor: "#EDEDED",
		boxShadow: `${boxShadow1} ${boxShadow1} ${boxShadow2} ${boxShadow1} rgba(0, 0, 0, 0.25)`,
		borderRadius: `${(width * 5.6) / 100}px`,
		marginRight: `${(width * 2.2) / 100}px`,
		padding: `${(width * 2.6) / 100}px`,
		width: `${(width * (isDesktop ? 26 : 38)) / 100}px`,
		border: "1px solid #EDEDED",
		height: `${(width * (isDesktop ? (comingSoon ? 31 : 33): 53)) / 100}px`,
		transition: ".1s",
		"&:hover": {
			...hover,
		}
	};

	const imageW = parseInt((width * (isDesktop ? 28.1 : 37.1)) / 100);
	const imageH = parseInt((width * (isDesktop ? 16.2 : 25.2)) / 100);

	const imageParams = {
		width: `${imageW}px !important`,
		height: `${imageH}px !important`,
		borderRadius: `${(width * 3) / 100}px`,
	};

	const titleParams = {
		fontSize: `${(width * 2.4) / 100}px`,
		lineHeight: `${(width * 3.3) / 100}px`,
		textAlign: "center",
	};

	const textSize = (width * (isDesktop ? 2 : 2.5)) / 100;
	const addressParams = {
		fontSize: `${textSize}px`,
		lineHeight: `${(width * (isDesktop ? 2.7 : 3.5)) / 100}px`,
		textAlign: "center",
	};

	return (
		<MUI.Box onClick={() => {
			if(comingSoon) {
				window.location.href = "/coming-soon";
			}
		}} sx={{cursor: comingSoon ? "pointer" : "default", ...boxParams}}>
			<Flex alignItems="center">
				<Image
					alt={ALT_IMGS["locations"][value].altImg}
					src={src(imageW, imageH)}
					{...imageParams}
					style={{ objectFit: "cover" }}
				/>
			</Flex>
			<Flex flexDirection="column">
				<Box>
					<Text {...titleParams} bold>
						{title}
					</Text>
				</Box>
				<Box>
					<Text {...addressParams}>{address1}</Text>
				</Box>
				<Box>
					<Text {...addressParams}>{address2}</Text>
				</Box>
				<Box>
					<Text {...addressParams}>{phone}</Text>
				</Box>
				<Box>
					{openHours.map((hours, i) => {
						return (
							<Text
								key={`#hours-${i}`}
								style={{ textAlign: "left !important" }}
								{...addressParams}
							>
								<span style={{ fontWeight: "bold" }}>{hours.days} </span>
								{hours.time}
							</Text>
						);
					})}
					{
						comingSoon && <Text style={{ textAlign: "center", fontSize: textSize, fontWeight: "bold", marginTop: "5%" }}> <a href="/coming-soon">  Coming Soon </a></Text>
					}
				</Box>
			</Flex>
		</MUI.Box>
	);
};
